import React from 'react'
import minus from '../../assets/images/Minus Blue.svg'
import plus from '../../assets/images/Plus Blue.svg'
import './Quantity.scss'

interface IProps {
  value?: any,
  increment?: any,
  decrement?: any,
  onChange?: any,
  disableFlg?:any,
  disable?:any,
  inputRef?:any,
  onKeyPress?:any,
  onBlur?:any,
  onKeyDown?:any,
  disabledQuantity?:any,
  name?:any,
  className?:any,
  'data-attribute'?: any,
}
const Quantity = ({ value = 0, onKeyPress, increment, decrement, onChange, disableFlg = false,disable= false,inputRef,onBlur, onKeyDown, disabledQuantity= false,name,className, 'data-attribute': dataAttribute}:IProps) => {
  return <div className={` ${className} quantity-spinner`} data-attribute={dataAttribute}>
      <button disabled= {disableFlg} className='control' onClick={decrement} name={name} data-attribute="index_name_Button">
        <img src={minus} alt='minus' className='minus-icon'/>
      </button>
      <div><input disabled= {disabledQuantity} type='text' value={value} className='form-control'
       ref={inputRef} onBlur={onBlur} onKeyDown={onKeyDown}
       onChange={onChange} onKeyPress={onKeyPress} name={name} data-attribute="index_name_Input" /></div>
      <button className='control' onClick={increment} disabled={disable} name={name} data-attribute="index_name_Button_2">
        <img src={plus} alt='plus' className='plus-icon'/>
      </button>
  </div>
}

export default Quantity
